import { render, staticRenderFns } from "./menuProfile.vue?vue&type=template&id=2a1f0eb5&lang=pug"
import script from "./menuProfile.vue?vue&type=script&lang=js"
export * from "./menuProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports